import {
    Box,
    Button,
    Typography,
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { ROUTES } from 'routes/constants';
import ContainerPainel from 'components/container_painel';
import { getModulesList, getPermission } from 'api/permission/manage-pemission.api';
import { useEffect, useState } from 'react';
import { ListDropdown } from 'api/common.types';
import { getGroupsDropdown } from 'api/group/group.api';
import { Module, PermissionFormData } from 'types/permission';
import PermissionView from 'components/permission/permission_data_view';
import { convertPermissionData } from 'utils/conversor';
import { getProfilesDropdown } from 'api/profile/profile.api';
import { useAuth } from 'contexts/auth/auth_context';
  
const administratorsList: string[]= ['ADMINISTRADOR'];
const PermissionViewPage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();


  const { user } = useAuth();
  const isAdministrator = administratorsList.includes(user!.permission.name);

  useEffect(() => {
    if (!isAdministrator) {
      navigate(ROUTES.HOME);
    }
  }, [isAdministrator, navigate]);

    const pathParts = location.pathname.split('/');
    const permissionUuid = pathParts[3];
  
    const [permissionDetails, setPermissionDetails] = useState<PermissionFormData | null>(null);
    const [modules, setModules] = useState<Module[]>([]);
    const [groupsDropdown, setGroupsDropdown] = useState<ListDropdown[]>([]);
    const [profilesGroup, setProfilesGroup] = useState<ListDropdown[]>([]);

    useEffect(() => {
      const fetchDropdowns = async () => {
        const result = await getGroupsDropdown();
        setGroupsDropdown(result.data);
      };

      const fetchModules = async () => {
        const result = await getModulesList({});
        setModules((result.data.filter( (module: Module) => module.name !== 'OTHERS')));
      };

      const fetchProfilesSubgroup = async () => {
        const result =await getProfilesDropdown();
        setProfilesGroup(result.data);
      };
  
      fetchModules();
      fetchDropdowns();
      fetchProfilesSubgroup();
    }, []);


    useEffect(() => {
      const fetchPermissionDetails = async (uuid: string) => {
        try {
          const permission: PermissionFormData = convertPermissionData((await getPermission(uuid)));
          setPermissionDetails(permission);
        } catch (error) {
          console.error('Error fetching permission details:', error);
        }
      };
  
      if (permissionUuid) {
        fetchPermissionDetails(permissionUuid);
      }
    }, [permissionUuid]);
  
    return (
      <ContainerPainel
        pagina="Visualizar Perfil"
        showBackButton={true}
      >
        <Box sx={{ backgroundColor: '#FAFAFA' }}>
          <Box sx={{ height: '79px', gap: '24px' }}>
            <Typography sx={{ textAlign: 'center' }} variant='h5'>
              Visualização de Perfil
            </Typography>
            <Typography
              sx={{
                fontFamily: 'Roboto',
                fontSize: '16px',
                fontWeight: 400,
                lineHeight: '22.88px',
                letterSpacing: '0.17px',
                textAlign: 'center',
                marginTop: '20px',
              }}
            >
              Confira os detalhes do perfil de permissão.
            </Typography>
          </Box>
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              flexWrap: 'nowrap',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {permissionDetails && (
              <PermissionView
                values={permissionDetails}
                groupList={groupsDropdown}
                modules={modules}
                profileSubgroupList={profilesGroup}
              />
            )}
          </Box>
          <Box sx={{ justifySelf: 'center', padding: '32px', textAlign: 'center' }}>

            <Button
                variant='text'
                onClick={() => navigate(ROUTES.MANAGE_PERMISSIONS)}
                sx={{
                    fontFamily: 'Roboto',
                    fontSize: '14px',
                    fontWeight: 500,
                    lineHeight: '24px',
                    letterSpacing: '0.4px',
                    textAlign: 'left',
                    color: '#0048B6',
                    marginRight: '20px',
                }}
                >
                VOLTAR
            </Button>
          </Box>
        </Box>
      </ContainerPainel>
    );
  };
  
  export default PermissionViewPage;
  